var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useMemo } from "react";
import { useTable, usePagination, useSortBy, } from "react-table";
import { FTLTableRow } from "./FTLTableRow";
import { FTLTableCell } from "./FTLTableCell";
import { Box, makeStyles } from "@material-ui/core";
import { FTLTableFooter } from "./FTLTableFooter";
import { FTLTableBody } from "./FTLTableBody";
import { FTLLoader } from "../FTLLoader";
import { SortIcon } from "../icons";
import { FTLTypography } from "../FTLTypography";
import { Skeleton } from "@material-ui/lab";
export { FTLPaginationButton } from "./FTLPaginationButton";
export { FTLTableBody } from "./FTLTableBody";
export { FTLTableCell } from "./FTLTableCell";
export { FTLTableRow } from "./FTLTableRow";
export const FTLTable = ({ showHeader = true, showFooter = true, columns, data, isFetching, hasData = Boolean(data === null || data === void 0 ? void 0 : data.length), isSearching, pageCount = 0, rowHeight = 40, type, noDataMessage = (React.createElement(FTLTypography, { variant: "h2", color: "secondary" }, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F")), noFilteredDataMessage = (React.createElement(FTLTypography, { variant: "h2", color: "secondary" }, "\u041F\u043E\u0438\u0441\u043A \u043D\u0435 \u0434\u0430\u043B \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432")), rowDisable, onRowClick, tableState, actionsSize = 1, setTableState, }) => {
    const tableData = useMemo(() => (!hasData ? Array(tableState === null || tableState === void 0 ? void 0 : tableState.pageSize).fill({}) : data), [data]);
    const tableColumns = useMemo(() => isFetching && !hasData
        ? columns.map((column) => (Object.assign(Object.assign({}, column), { type: "skeleton", Cell: (column === null || column === void 0 ? void 0 : column.accessor) === "action" ? (React.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", mt: 1, ml: -2 }, Array(actionsSize).fill(React.createElement("div", { style: { marginLeft: 8 } },
                React.createElement(Skeleton, { variant: "circle", width: "24px", height: "24px" }))))) : (React.createElement(Skeleton, { variant: "text" })) })))
        : columns, [columns, isFetching, hasData]);
    const { getTableProps, getTableBodyProps, prepareRow, page, headerGroups, } = useTable({
        autoResetPage: true,
        columns: tableColumns,
        data: tableData,
        defaultCanSort: false,
        disableMultiSort: false,
        manualPagination: true,
        pageCount,
    }, useSortBy, usePagination);
    const rowRefs = useRef([]);
    const [showFirstColumnShadow, setShowFirstColumnShadow] = useState(false);
    const classes = useStyles({
        firstColumnWidth: columns[0].width || 0,
        lastColumnWidth: columns[columns.length - 1].width || 0,
        tableHeight: rowRefs.current.reduce((prev, value) => { var _a; return prev + ((_a = value === null || value === void 0 ? void 0 : value.clientHeight) !== null && _a !== void 0 ? _a : 0); }, 0),
        showFirstColumnShadow,
        onRowClick,
        type,
        hasData,
        isFetching,
    });
    if (hasData || isFetching) {
        return (React.createElement(Box, { position: "relative" },
            isFetching && hasData && (React.createElement(FTLLoader, { alignItems: "center", justifyContent: "center", height: showFooter ? "calc(100% - 80px)" : "100%", width: "100%", position: "absolute", zIndex: 1301 })),
            React.createElement("div", { className: classes.overflowTableWrapper, onScroll: (e) => {
                    if (showFirstColumnShadow && e.currentTarget.scrollLeft === 0)
                        setShowFirstColumnShadow(false);
                    else if (hasData)
                        setShowFirstColumnShadow(true);
                } },
                React.createElement("table", Object.assign({}, getTableProps(), { className: classes.table, cellPadding: "0", cellSpacing: "0" }),
                    showHeader && (React.createElement("thead", null, headerGroups.map((headerGroup, rowIndex) => {
                        return (React.createElement(FTLTableRow, Object.assign({ type: "head" }, headerGroup.getHeaderGroupProps()), headerGroup.headers.map((column, index) => {
                            var _a;
                            const _b = column.getHeaderProps(column.getSortByToggleProps()), { onClick } = _b, otherHeadProps = __rest(_b, ["onClick"]);
                            const props = Object.assign(Object.assign({ type: "head", textAlign: (_a = column === null || column === void 0 ? void 0 : column.align) !== null && _a !== void 0 ? _a : "left", minWidth: column.width, isFocusable: column.canSort && tableState, tabIndex: column.canSort && tableState ? index : -1 }, otherHeadProps), { onClick: () => {
                                    if (column.canSort && setTableState && tableState)
                                        if (tableState.sortName === column.id &&
                                            tableState.sortDirection === "DESC")
                                            setTableState({
                                                sortDirection: "ASC",
                                                sortName: column.id,
                                            });
                                        else
                                            setTableState({
                                                sortDirection: "DESC",
                                                sortName: column.id,
                                            });
                                }, children: (React.createElement(Box, { display: column.canSort ? "inline-flex" : "block", overflow: "hidden", flexDirection: column.canSort && (column === null || column === void 0 ? void 0 : column.reverse)
                                        ? "row-reverse"
                                        : "row" },
                                    column.render("Header"),
                                    column.canSort && tableState ? (React.createElement(SortIcon, { sort: tableState.sortName === column.id
                                            ? tableState.sortDirection
                                            : undefined })) : null)) });
                            if (index === 0 && type === "fixedColumns")
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(FTLTableCell, Object.assign({}, props, { width: column.width, key: props.key + "_clone" })),
                                    React.createElement(FTLTableCell, Object.assign({}, props, { width: column.width }))));
                            return React.createElement(FTLTableCell, Object.assign({}, props));
                        })));
                    }))),
                    React.createElement(FTLTableBody, Object.assign({}, getTableBodyProps(), { showHeader: showHeader, style: isFetching && hasData ? { opacity: 0.5 } : {} }), page.map((row, rowIndex) => {
                        prepareRow(row);
                        const isDisabled = row.isDisabled || (rowDisable && rowDisable(row));
                        return (React.createElement(FTLTableRow, Object.assign({}, row.getRowProps(), { height: rowHeight, ref: (rowRef) => {
                                rowRefs.current[rowIndex] = rowRef;
                            }, onClick: (e) => {
                                if (!isFetching && hasData && onRowClick)
                                    onRowClick(row, e);
                            } }), row.cells.map((cell, index) => {
                            var _a, _b, _c, _d, _e;
                            const props = Object.assign(Object.assign({}, cell.getCellProps()), { isDisabled: typeof cell.value === "object" ? false : isDisabled, tabIndex: -1, textAlign: ((_a = cell.column) === null || _a === void 0 ? void 0 : _a.align) ? "right" : "left", children: cell.value || cell.column.type === "skeleton"
                                    ? cell.render("Cell")
                                    : "—" });
                            if (index === 0 && type === "fixedColumns")
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(FTLTableCell, Object.assign({}, props, { width: cell.column.width, height: ((_c = (_b = rowRefs.current[rowIndex]) === null || _b === void 0 ? void 0 : _b.clientHeight) !== null && _c !== void 0 ? _c : 8) - 8, key: props.key + "_clone" })),
                                    React.createElement(FTLTableCell, Object.assign({}, props, { width: cell.column.width }))));
                            else if (index === row.cells.length - 1)
                                return (React.createElement(FTLTableCell, Object.assign({}, props, { className: classes.actionCell, height: ((_e = (_d = rowRefs.current[rowIndex]) === null || _d === void 0 ? void 0 : _d.clientHeight) !== null && _e !== void 0 ? _e : 8) - 8 })));
                            return React.createElement(FTLTableCell, Object.assign({}, props));
                        })));
                    })))),
            showFooter && tableState && (React.createElement(FTLTableFooter, { pageIndex: tableState.pageIndex, pageSize: tableState.pageSize, pageCount: pageCount, setPageSize: (pageSize) => setTableState && setTableState({ pageSize }), gotoPage: (pageNumber) => {
                    setTableState && setTableState({ pageIndex: pageNumber - 1 });
                } }))));
    }
    else if (isSearching && !hasData) {
        return (React.createElement(Box, { mt: 32.5, textAlign: "center" },
            React.createElement("div", null, noFilteredDataMessage)));
    }
    else {
        return (React.createElement(Box, { mt: 32.5, textAlign: "center" },
            React.createElement("div", null, noDataMessage)));
    }
};
const useStyles = makeStyles((theme) => ({
    actionCell: {
        paddingTop: 3.5,
        paddingBottom: 3.5,
        minHeight: 0,
    },
    overflowTableWrapper: {
        display: "block",
        overflowX: "auto",
        overflowY: "hidden",
    },
    table: ({ firstColumnWidth, lastColumnWidth, tableHeight, showFirstColumnShadow = false, onRowClick, type, isFetching, hasData, }) => {
        const styles = {
            borderCollapse: "collapse",
            borderSpacing: 0,
            width: "100%",
            "& td > div button": {
                padding: 0,
            },
            "& tbody tr": !isFetching && hasData && onRowClick && !type
                ? {
                    cursor: "pointer",
                    "&:hover": {
                        transition: "box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 0 3px 1px rgba(0, 0, 0, 0.08)",
                    },
                }
                : null,
        };
        if (type === "fixedColumns")
            return Object.assign(Object.assign({}, styles), { "& tbody tr": {
                    cursor: "pointer",
                    "&:hover": {
                        transition: "box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 0 3px 1px rgba(0, 0, 0, 0.08)",
                    },
                    "& > td:last-child": {
                        width: lastColumnWidth,
                        backgroundColor: theme.palette.text.onColor,
                        boxShadow: "none",
                        "&::before": {
                            content: "''",
                            position: "absolute",
                            left: -8,
                            display: "block",
                            height: "calc(100% - 5px)",
                            width: 8,
                            background: "linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)",
                        },
                    },
                }, "& tr": {
                    "& > td:first-child, & > th:first-child": {
                        position: "absolute",
                        zIndex: 2,
                        left: 0,
                        width: firstColumnWidth,
                        paddingTop: 4,
                        marginTop: 4,
                        paddingBottom: 4,
                        marginBottom: 4,
                        boxShadow: "none",
                        backgroundColor: theme.palette.text.onColor,
                    },
                    "& > td:last-child, & > th:last-child": {
                        position: "absolute",
                        right: 0,
                        visibility: "hidden",
                    },
                    "&:hover > td:last-child": {
                        visibility: "visible",
                    },
                    "&:first-child > td:first-child::after, &:first-child > th:first-child::after": {
                        content: "''",
                        position: "absolute",
                        right: 0,
                        display: "block",
                        width: "100%",
                        boxShadow: "4px 0 4px -2px rgba(0, 0, 0, 0.08)",
                        transition: "opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        opacity: showFirstColumnShadow ? 1 : 0,
                    },
                    "&:first-child > td:first-child::after": {
                        height: tableHeight,
                        top: -4,
                    },
                    "&:first-child > th:first-child::after": {
                        height: 32,
                        top: 0,
                    },
                } });
        return styles;
    },
}));
//# sourceMappingURL=index.js.map